export const log = (str: any, object: any) => {
	// if (process.env.REACT_APP_NODE_ENV !== 'production') {
	console.log(str, object);
	// }
	return false;
};
